import { globalEntitlements } from '../utils/globalEntitlements';

export const DOMAIN_NAME_REG_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.domainNameReg.buyBox.bulletPoint1' },
        { title: 'productPage.domainNameReg.buyBox.bulletPoint2' },
        { title: 'productPage.domainNameReg.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.domainNameReg.buyBox.productName',
      interactService: {
        service: 'domain_name_reg'
      }
    }],
    headerPicture: {
      src: '/s2/raster/smiling-cafe-coffee.png',
      alt: 'productPage.domainNameReg.heroPicture.altText'
    },
    headline: 'productPage.domainNameReg.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.domainNameReg.page.subheader'
  },
  benefit: {
    title: 'productPage.domainNameReg.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.domainNameReg.valueProp.propTitle1',
        description: 'productPage.domainNameReg.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/computerrounded.svg',
        title: 'productPage.domainNameReg.valueProp.propTitle2',
        description: 'productPage.domainNameReg.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/campaignrounded.svg',
        title: 'productPage.domainNameReg.valueProp.propTitle3',
        description: 'productPage.domainNameReg.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/helpoutlinerounded.svg',
    title: 'productPage.domainNameReg.topFeature.title',
    subheader: 'productPage.domainNameReg.topFeature.subheader',
    image: '/s2/raster/laptop-kitchen-white.png',
    alt: 'productPage.domainNameReg.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.domainNameReg.howItWorks.title',
    items: [
      {
        title: 'productPage.domainNameReg.howItWorks.step1',
        description: 'productPage.domainNameReg.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.domainNameReg.howItWorks.step2',
        description: 'productPage.domainNameReg.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.domainNameReg.howItWorks.step3',
        description: 'productPage.domainNameReg.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/outside-phone-smiling.png',
    alt: 'productPage.domainNameReg.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.domainNameReg.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.domainNameReg.frequentlyAskedQuestions.faq1',
        answer: 'productPage.domainNameReg.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.domainNameReg.frequentlyAskedQuestions.faq2',
        answer: 'productPage.domainNameReg.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.domainNameReg.frequentlyAskedQuestions.faq3',
        answer: 'productPage.domainNameReg.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.domainNameReg.frequentlyAskedQuestions.faq4',
        answer: 'productPage.domainNameReg.frequentlyAskedQuestions.faqAnswer4'
      }
    ]
  },
  assistance: {
    title: 'productPage.domainNameReg.needAssistance.title',
    getInTouch: 'productPage.domainNameReg.needAssistance.getInTouch',
    actions: 'productPage.domainNameReg.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.domainNameReg.buyBox.buttonLabel'
  }).allowMultiplePurchases().build()
};
